import auth from "./auth";
import partners from "./partners";
import campaigns from "./campaigns";
import payment from "./payment";
import users from "./users";

export default {
  auth,
  partners,
  campaigns,
  payment,
  users
};
